const readBase64File = (file: string, mimeType: string) =>
    file.includes(';base64,') ? file : `data:${mimeType};base64,${file}`;

export { readBase64File };
